import { useWizard } from "react-use-wizard";
import dealServiceSteps from "./dealServiceSteps";
import { IFillDataWizardDealService, TKeyOfDataWizardDealService } from "..";
import FeaturesFacilityStep, {
  IDataFeatures,
} from "../../../../../shared/wizard/steps/featuresStep";

interface IStepDealService_4 {
  onChange: (data: Partial<IFillDataWizardDealService>) => void;
  data: Partial<IFillDataWizardDealService>;
  onReset: (keys: TKeyOfDataWizardDealService[], data?: number[]) => void;
  isNextStepDisabled: boolean;
}

const StepDealService_4 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IStepDealService_4) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(dealServiceSteps.step_3);
    onReset(["maternityCapital", "encumbrance", "childrenOwn"]);
  };

  const handleNextStep = () => {
    goToStep(dealServiceSteps.step_5);
  };

  return (
    <div>
      <FeaturesFacilityStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNextStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data as IDataFeatures}
        mode="serviceDeal"
      />
    </div>
  );
};

export default StepDealService_4;
